import { formatMoney, formatRelativeTime } from "@/lib/format";
import { Trash2 } from "lucide-react";

export default function TransactionFeed({ transactions, onDelete }) {
  return (
    <div
      data-testid="transaction-feed"
      className="chunky-card p-5 sm:p-6 mt-5"
      style={{ backgroundColor: "white" }}
    >
      <h2 className="font-display text-2xl sm:text-3xl text-navy mb-4">
        WHAT HAPPENED
      </h2>

      {transactions.length === 0 ? (
        <div className="py-10 text-center">
          <div className="font-display text-xl text-navy/60">
            No money moves yet!
          </div>
          <div className="font-display text-base text-navy/50 mt-1">
            Tap MAKE MONEY when you earn some 🪙
          </div>
        </div>
      ) : (
        <ul className="space-y-3">
          {transactions.map((tx) => {
            const isMake = tx.type === "make";
            const sign = isMake ? "+" : "−";
            const color = isMake ? "#1A8F2E" : "#D6321A";
            const bg = isMake ? "#E8FFD8" : "#FFE3DC";

            return (
              <li
                key={tx.id}
                data-testid={`tx-${tx.id}`}
                className="feed-item flex items-center justify-between gap-3 rounded-2xl border-3 border-navy p-3 sm:p-4"
                style={{
                  backgroundColor: bg,
                  borderWidth: 3,
                  boxShadow: "0 3px 0 0 #2A2D7C",
                }}
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <span
                      data-testid={`tx-amount-${tx.id}`}
                      className="font-display text-2xl sm:text-3xl"
                      style={{ color }}
                    >
                      {sign}{formatMoney(tx.amount)}
                    </span>
                    {isMake && tx.tag && (
                      <span
                        className="font-display text-xs uppercase px-2 py-0.5 rounded-full border-2 border-navy text-navy"
                        style={{
                          backgroundColor: tx.tag === "cash" ? "#7CE645" : "#29C7E8",
                        }}
                      >
                        {tx.tag}
                      </span>
                    )}
                  </div>
                  {!isMake && tx.description && (
                    <div className="font-display text-base sm:text-lg text-navy mt-0.5 truncate">
                      {tx.description}
                    </div>
                  )}
                  {isMake && !tx.description && (
                    <div className="font-display text-sm text-navy/70 mt-0.5">
                      Money in!
                    </div>
                  )}
                  <div className="font-display text-xs text-navy/60 mt-1">
                    {formatRelativeTime(tx.timestamp)}
                  </div>
                </div>

                <button
                  data-testid={`delete-tx-${tx.id}`}
                  onClick={() => onDelete(tx.id)}
                  className="w-10 h-10 rounded-full border-3 border-navy flex items-center justify-center hover:scale-105 transition-transform shrink-0"
                  style={{
                    backgroundColor: "white",
                    borderWidth: 3,
                    boxShadow: "0 3px 0 0 #2A2D7C",
                  }}
                  aria-label="Delete transaction"
                >
                  <Trash2 className="w-4 h-4 text-navy" strokeWidth={3} />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
